module.exports = __webpack_public_path__ + "img/SD.35ea53ce.svg";